var ModalMessage = function () {

};

var dialogSequence = 0;

/**
 * Aplica ao diálogo a semântica que o leitor de tela precisa e leva o foco para dentro dele.
 *
 * Precisa ser chamada em TODO ponto que abre um bootbox. Antes só o ModalMessage.confirm fazia
 * isso, então os demais diálogos — inclusive a confirmação de exclusão — não eram anunciados: o
 * usuário de leitor de tela não sabia que havia uma pergunta na tela.
 *
 * O gancho é o evento shown, e não um setTimeout: o foco só pode ser movido depois de o diálogo
 * estar visível, senão o navegador ignora o focus e o foco permanece no botão que abriu.
 *
 * @param {jQuery} dialog diálogo devolvido por bootbox.dialog.
 * @returns {jQuery} o mesmo diálogo, para permitir encadeamento.
 */
ModalMessage.applyDialogAccessibility = function (dialog) {
    if (!dialog)
        return dialog;

    dialog.on('shown.bs.modal', function () {
        var content = dialog.find('.modal-content');

        describeDialog(content, dialog.find('.modal-title'), dialog.find('.bootbox-body'));

        content.focus();
    });

    return dialog;
};

/**
 * Declara o elemento como diálogo e o associa ao próprio título e corpo.
 *
 * @param {jQuery} content elemento que representa o diálogo.
 * @param {jQuery} title título do diálogo.
 * @param {jQuery} body corpo do diálogo.
 */
function describeDialog(content, title, body) {
    content.attr('role', 'dialog');
    content.attr('aria-modal', 'true');
    content.attr('tabindex', '-1');

    if (title.length)
        content.attr('aria-labelledby', ensureId(title, 'wes-modal-title'));

    if (body.length)
        content.attr('aria-describedby', ensureId(body, 'wes-modal-body'));
}

/**
 * Devolve o id do elemento, criando um único quando ele não tem.
 *
 * @param {jQuery} element elemento que precisa ser referenciado.
 * @param {string} prefix prefixo do id gerado.
 * @returns {string} o id do elemento.
 */
function ensureId(element, prefix) {
    if (!element.attr('id')) {
        dialogSequence++;
        element.attr('id', prefix + '-' + dialogSequence);
    }

    return element.attr('id');
}

ModalMessage.show = function (message) {
    App.blockUI({ textOnly: false, boxed: true, message: message, zIndex: 11000 });
};

ModalMessage.hide = function (elmentId) {
    App.unblockUI();
};

ModalMessage.alert = function (title, message, callback) {
    var options = {
        title: title,
        message: message
    };

    if (callback != null) {
        options.buttons = {
            main: {
                label: "Ok",
                className: "btn-primary",
                callback: function () {
                    callback();
                }
            }
        };
    }

    ModalMessage.applyDialogAccessibility(bootbox.dialog(options));
};

ModalMessage.confirm = function (title, message, callback, cancelCallback) {
    const dialog = bootbox.dialog({
        title: title,
        message: message,
        onEscape: function () {
            bootbox.hideAll();
            if (typeof cancelCallback != 'undefined')
                cancelCallback();
        },
        buttons: {
            success: {
                label: BennerTranslations.yes,
                className: 'blue btn-primary',
                callback: function () {
                    callback();
                }
            },
            main: {
                label: BennerTranslations.no,
                className: 'default',
                callback: function () {
                    if (typeof cancelCallback != 'undefined')
                        cancelCallback();
                }
            }
        }
    });

    // Antes daqui saía um setTimeout de 50ms que aplicava estes atributos e movia o foco. O
    // diálogo do bootbox ainda está aparecendo nesse instante, então o focus podia não pegar.
    return ModalMessage.applyDialogAccessibility(dialog);
};

export default ModalMessage;